// extracted by mini-css-extract-plugin
export default {"page":"event-page_page__+9ZBx"};